import { Create, useForm } from "@refinedev/antd";
import { Form, Input, Tag, Space } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { BankOutlined, PhoneOutlined } from "@ant-design/icons";

import { IShipco } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";

export const ShipcoCreate: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<IShipco>({ redirect: "list" });

  return (
    <Create
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        subTitle: "setup new shipping company",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Company Registration"
            subtitle="Legal registration details"
            icon={<BankOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Registration Name"
                name="registrationName"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item label="Registration Number" name="registrationNumber">
                <Input />
              </Form.Item>
              <Form.Item label="GST Number" name="gstNumber">
                <Input />
              </Form.Item>
              <Form.Item label="Accreditation Number" name="accreditationNumber">
                <Input />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>

          <FormSection
            title="Contact Information"
            subtitle="Company contact details"
            icon={<PhoneOutlined />}
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Phone"
                name="phone"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Communication Email"
                name="email"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>
        </Space>
      </Form>
    </Create>
  );
};
